export class LoginRequest {
    username: string;
    password: string;
    mfa: string;
    isWindowsAuthentication: boolean;
    isPluginAuthentication: boolean;
    authPluginID: string;
    externalUserGroups: string[] = [];
    dashboardSharingToken: string;
    organizationName: string;
    isWSFedAuthentication: boolean;

    constructor(
        username: string,
        password: string,
        mfa: string,
        isWindowsAuthentication: boolean,
        isPluginAuthentication: boolean,
        authPluginID: string,
        externalUserGroups: string[],
        dashboardSharingToken: string,
        organizationName: string,
        isWSFedAuthentication: boolean
    ) {
        this.username = username;
        this.password = password;
        this.mfa = mfa;
        this.isWindowsAuthentication = isWindowsAuthentication;
        this.isPluginAuthentication = isPluginAuthentication;
        this.authPluginID = authPluginID;
        this.externalUserGroups = externalUserGroups;
        this.dashboardSharingToken = dashboardSharingToken;
        this.organizationName = organizationName;
        this.isWSFedAuthentication = isWSFedAuthentication;
    }
}
